import { render, staticRenderFns } from "./JavascriptComponentsSection.vue?vue&type=template&id=6fc83972&scoped=true"
import script from "./JavascriptComponentsSection.vue?vue&type=script&lang=js"
export * from "./JavascriptComponentsSection.vue?vue&type=script&lang=js"
import style0 from "./JavascriptComponentsSection.vue?vue&type=style&index=0&id=6fc83972&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc83972",
  null
  
)

export default component.exports